import {
    normalizeAuthoringComparisonDiffHtml,
    normalizeAuthoringSnapshotHtml,
} from "./authoring-comparison-normalization"

const DEFAULT_MAX = 2000

const snapshotCache = new Map()
const diffCache = new Map()

export function memoizeNormalizer(fn, { max = DEFAULT_MAX, cache = new Map() } = {}) {
    return function memoized(value) {
        if (typeof value !== "string") return fn(value)
        if (cache.has(value)) return cache.get(value)
        const result = fn(value)
        cache.set(value, result)
        if (cache.size > max) cache.delete(cache.keys().next().value)
        return result
    }
}

export const memoizedNormalizeAuthoringSnapshotHtml = memoizeNormalizer(normalizeAuthoringSnapshotHtml, {
    cache: snapshotCache,
})

export const memoizedNormalizeAuthoringComparisonDiffHtml = memoizeNormalizer(normalizeAuthoringComparisonDiffHtml, {
    cache: diffCache,
})

export function __resetMemoCachesForTests() {
    snapshotCache.clear()
    diffCache.clear()
}
